export default function camelCaseToKebabCase(word){
  const letters = word.split('')

  return letters.map(letter=>{
    if(letter ===  letter.toUpperCase() && letter !== '-')
      return `-${letter.toLowerCase()}`

    return letter
  }).join('')
}